module.exports = __webpack_public_path__ + "img/1_028.367ae315.jpg";